<router-outlet></router-outlet>
<app-cookie-consent></app-cookie-consent>
<app-loader-modal></app-loader-modal>